import { Component, OnInit,Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_PM_Itme_Interface, PM_Itme_Interface } from 'src/app/Interface/PM_Itme_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PM_ItemService } from 'src/app/Service/PM/PM_Item.service';

@Component({
  selector: 'app-PMItemForm',
  templateUrl: './PMItemForm.component.html',
  styleUrls: ['./PMItemForm.component.scss']
})
export class PMItemFormComponent implements OnInit {

  @Input() inner_PM: PM_Itme_Interface = Empty_PM_Itme_Interface()
  @Input() inner_Parent:number




  constructor(
    private PM_Itme_Service: PM_ItemService,
    private Nav_Service: NavService,
    private Alertify_Service: AlertifyService,
  ) { }

  ngOnInit() {

    this.PMForm = new FormGroup({
      id: new FormControl(),
      Title: new FormControl(null, Validators.required),
    })

    this.Nav_Service.CheckValidPage(1158).subscribe(
      data => {
        this.get_Form_Title().setValue(this.inner_PM.title)

      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )

  }


  //#region  Form

  PMForm: FormGroup;

  get_Form_Title() {
    return this.PMForm.get('Title') as FormControl;
  }


  //#endregion

  InProccessing: boolean = false

  SubmitPMForm() {
    var Record: PM_Itme_Interface = Empty_PM_Itme_Interface()
    Record.id = this.inner_PM.id
    Record.title = this.get_Form_Title().value

    Record.parent = this.inner_Parent


    this.InProccessing = true
    this.PM_Itme_Service.AddEditPM(Record).subscribe(
      data => {
        this.InProccessing = false
        if (data.id == -2) {
          this.Alertify_Service.ErrorMessage("عنوان وارد شده در سامانه ثبت شده است")
        }
        else {

          this.inner_PM.id = data.id
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
        }
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }



}
